<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        template(v-if='settings.mode')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}:
            | {{ getModeName(settings.mode) }}
            br
        |  {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
        |  {{ difficultyValue }}
        br
        template(v-if='settings.amountOfActions')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}:
            | {{ settings.amountOfActions }}
            br
        template(v-if='settings.amountOfExamples')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
            br
        template(v-if="settings.speed && parametersFrom === 'homework'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
            | {{settings.speed}}
            | {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
            br
        template(v-if='settings.isSpeedIncrease')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_acceleration') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_For') }}
                | {{ settings.speedUp }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }}
                | {{ amountOfSpeedExercises }}
            br
        template(v-if='settings.isComplication')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_For') }}
                | {{ amountOfActions }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }}
                | {{ amountOfComplicationExercises }}
            br
        template(v-if='settings.fractions')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                | {{ fractionalPart }}
                | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
            br
        template(v-if='settings.mirror')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
            br
        template(v-if='settings.roundNumbers')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
            br
        template(v-if='settings.simple.length > 0 && game.slug !== "AdditionAndSubtractionMathMagic"')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_simple') }}:
            | {{ rulesArrayToString(settings.simple) }}
            br
        template(v-if='settings.brothers && settings.brothers.length > 0')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_brothers') }}:
            | {{ rulesArrayToString(settings.brothers) }}
            br
        template(v-if='settings.friends && settings.friends.length > 0')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_friends') }}:
            | {{ rulesArrayToString(settings.friends) }}
            br
        template(v-if='settings.brothersAndFriends && settings.brothersAndFriends.length > 0')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_brothersAndFriends') }}:
            | {{ rulesArrayToString(settings.brothersAndFriends) }}
            br
        template(v-if='Array.isArray(settings.jumpOver)')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_transitionThrough') }}
            template(v-for='(setting, index) in settings.jumpOver')
                | {{ setting.value }}
                template(v-if='index !== settings.jumpOver.length - 1') ,
            br
        template(v-else-if='settings.jumpOver')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_transitionThrough') }}:
            | {{ settings.jumpOver.value }}
            br
        template(v-if="settings.extraOptions && parametersFrom !== 'course'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.pictures) }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.music) }}
            br
            | X2:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.x2) }}
            br
            | {{ motionLabel }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.motion) }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_voiceActing') }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.voiceOver) }}
            br
        slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework'
            },
            userId: Number
        },
        computed: {
            amountOfComplicationExercises () {
                return this.settings.tasksForComplication + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.settings.tasksForComplication);
            },
            amountOfSpeedExercises () {
                return this.settings.tasksForSpeedUp + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.settings.tasksForSpeedUp);
            },
            amountOfActions () {
                return this.settings.complication + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_actionDeclination', this.settings.complication);
            },
            fractionalPart() {
                return this.settings.fractionalPart + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_numDeclination', this.settings.fractionalPart);
            },
            difficultyValue () {
                return this.settings.combining
                        ? this.$i18n.t('common')[this.settings.difficult]
                        + ' (' + this.$i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')'
                        : this.$i18n.t('common')[this.settings.difficult]
            },
            motionLabel () {
                return this.$i18n.t('trainer.trainer_gameFormSetting_movement', {
                    element: this.$i18n.t('trainer.trainer_gameFormSettingValue_numbers')
                })
            }
        },
    }
</script>
